/* tslint:disable */

/**
 */
export class DefaultEquipment {
    energyId?: number;
    construct?: string;
    familyId?: number;
    stdId?: number;
    batchProcess?: number;
    equipseriesId?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/default-equipment.ts